import { LinkOutlined, PlusOutlined, SearchOutlined } from '@ant-design/icons';
import {
  NoticeItemInterface,
  NoticeListFilterInterface
} from '@api/announcement/type';
import {
  createProject,
  projectRecall,
  queryProjectPage,
  updateProject
} from '@api/project';
import ZeissButton from '@components/button';
import ZeissInput from '@components/input';
import RevertModal from '@components/revertModal';
import ZeissTable from '@components/table';
import ZeissTabs from '@components/tabs';
import {
  DEFAULT_DATE_FORMAT,
  DEFAULT_PAGINATION,
  ROLE_KEYS_MAP
} from '@constants';
import { PaginationInterface } from '@constants/types';
import { DicListHook } from '@hooks/useDicListHook';
import { UseSystemCity } from '@hooks/useSystemCity';
import { userInfo } from '@store';
import { getCityItem, getDomianRelativeUrl } from '@utils/tool';
import type { TablePaginationConfig, TableProps } from 'antd';
import { Badge, Form } from 'antd';
import { ColumnsType } from 'antd/es/table';
import dayjs from 'dayjs';
import { useEffect, useMemo, useRef, useState } from 'react';
import { useRecoilState } from 'recoil';
import { CreateProject } from '../../../components/ProjectFromComponents/CreateProject';
import {
  PROJECT_MODE,
  projectStatusMap
} from '../../../components/ProjectFromComponents/data';
import { initialSubjectMatterItemValues } from '../AnnouncementList/Announcement/CreateAnnouncement';
import { itemsBase, use_PROJECT_LIST_COLUMNS } from './data';
import './index.scss';
import ProjectSearchForm from './searchCriteriaForm';
import { NOTICE_STATUS } from '../AnnouncementList/announcement';

const ProjectList = () => {
  const [open, setOpen] = useState(false); //新建公告弹框
  const [pagination, setPagination] =
    useState<PaginationInterface>(DEFAULT_PAGINATION);
  const [tabStatus, setTabStatus] = useState('');
  const [dataSource, setDataSource] = useState([]);
  const [tabCounts, setTabCount] = useState<any>({});
  const inputFilterRef = useRef<any>(null);
  const [form] = Form.useForm();
  const [subjectMatterForm] = Form.useForm();
  const searchCriteriaFromRef = useRef<any>(null);
  const dicList = DicListHook();
  const { data: systemCity, provinceData: filterFormSystemCity } =
    UseSystemCity();
  const [userInfos] = useRecoilState(userInfo);
  const [revertModalShow, setRevertModalShow] = useState<boolean>(false);
  const [curTableItem] = useState<any>({});
  const PROJECT_LIST_COLUMNS = use_PROJECT_LIST_COLUMNS();

  const getList = async (
    pageInfo: PaginationInterface = pagination,
    filter: any = { noticeStatus: tabStatus }
  ) => {
    const params = {
      ...filter,
      ...pageInfo
    };
    const res = await queryProjectPage(params);
    const { page, ...restCount } = res ?? {};

    setDataSource(page?.records);
    setTabStatus(params.noticeStatus);
    setPagination({
      ...pagination,
      pageNumber: page.current,
      pageSize: page.size,
      total: page.total
    });
    setTabCount({
      ...restCount
    });
  };

  useEffect(() => {
    getList();
  }, []);

  const handleTableChange = async (pagination: any) => {
    const formValue = await getCurrentFilterParams();
    getList({
      ...formValue,
      pageNumber: pagination.current,
      pageSize: pagination.pageSize
    });
  };

  const pageProps: TablePaginationConfig = {
    current: pagination.pageNumber,
    pageSize: pagination.pageSize,
    total: pagination.total ?? 10
  };

  const goToDetailPage = (record: any) => {
    window.open(
      `${getDomianRelativeUrl()}/projectList/projectDetail?noticeProjectCode=` +
        record?.noticeCode
    );
  };

  const handleProjectFormOk = async (data: NoticeItemInterface) => {
    data?.subjectMatterProjectCode
      ? await updateProject(data)
      : await createProject(data);
    setOpen(false);
    form.resetFields();
    await confirmAddNoticeCallback();
  };

  const onRevertConfirm = async () => {
    const params = {
      code: curTableItem.subjectMatterCode,
      operatorUserId: userInfos.userId,
      operatorUserName: userInfos.realName
    };
    await projectRecall(params);
    handleInputSubmit();
    setRevertModalShow(false);
  };

  // const onRevertClick = (record: any) => {
  //   setCurTableItem(record);
  //   setRevertModalShow(true);
  // };

  // const actionColumn: any = {
  //   title: '操作',
  //   dataIndex: 'action',
  //   key: 'action',
  //   width: 80,
  //   fixed: 'right',
  //   render: (val: any, record: any) => {
  //     return (
  //       <div>
  //         <ZeissButton
  //           type="link"
  //           onClick={() => onRevertClick(record)}
  //           style={{ paddingLeft: 0 }}
  //         >
  //           撤回
  //         </ZeissButton>
  //       </div>
  //     );
  //   }
  // };

  const columnsList: ColumnsType = [
    ...PROJECT_LIST_COLUMNS.map((v) => {
      const { key } = v;
      if (key === 'noticeCode') {
        v.render = (val: any, record: any) => {
          //  是否逾期 1逾期 0没有 已删除/结束招标不显示逾期角标
          const { overdue } = record;
          return (
            <div>
              {val}
              {overdue === 1 &&
              record.noticeStatus !== NOTICE_STATUS.EndTender &&
              record.noticeStatus !== projectStatusMap.deleted ? (
                <div className="overdue_wrap">
                  <span className="overdue">逾期</span>
                </div>
              ) : null}
            </div>
          );
        };
      }
      if (key === 'noticeName') {
        v.render = (value, record) => {
          return (
            <div
              className="list_noticeName"
              onClick={() => goToDetailPage(record)}
            >
              <LinkOutlined />
              <span className="list_noticeName_text">{value}</span>
            </div>
          );
        };
      }
      return v;
    })
    // {
    //   title: '状态',
    //   dataIndex: 'noticeStatusValue',
    //   key: 'noticeStatusValue',
    //   width: 160,
    //   fixed: 'right',
    //   render: (val: any, record: any) => {
    //     const { noticeStatus } = record;
    //     return (
    //       <Tag className={`tag_base ${tagClassMap[noticeStatus]}`}>{val}</Tag>
    //     );
    //   }
    // }
  ];

  // if (tabStatus === projectStatusMap.deleted) {
  //   columnsList.push(actionColumn);
  // }

  const tableProps: TableProps<any> = {
    columns: columnsList,
    dataSource,
    pagination: pageProps,
    rowKey: 'id',
    onChange: handleTableChange,
    bordered: false,
    scroll: {
      x: 2800
    }
  };

  const dealerNotShowKeys = [projectStatusMap.replenishOppid];

  const items = useMemo(() => {
    let arr = itemsBase;
    if (userInfos.roleKeys === ROLE_KEYS_MAP.dealer) {
      arr = itemsBase?.filter((item) => !dealerNotShowKeys.includes(item.key));
    }
    return arr?.map((item) => {
      const { key, label } = item;
      let curLable = label;
      if (key === projectStatusMap.duringTender) {
        curLable = (
          <div className="pc-ann-layout">
            {label}
            <Badge count={tabCounts.countStayTenderIng} offset={[5, 0]}></Badge>
          </div>
        );
      } else if (key === projectStatusMap.waittingForTender) {
        curLable = (
          <div className="pc-ann-layout">
            {label}
            <Badge count={tabCounts.countStayTender} offset={[5, 0]}></Badge>
          </div>
        );
      } else if (key === projectStatusMap.replenishOppid) {
        curLable = (
          <div className="pc-ann-layout">
            {label}
            <Badge count={tabCounts.countStayOppId} offset={[5, 0]}></Badge>
          </div>
        );
      }
      return {
        ...item,
        label: curLable
      };
    });
  }, [userInfos?.roleKeys, tabCounts]);

  const onTabsChange = async (key: string) => {
    const formValue = await getCurrentFilterParams();
    getList(pagination, { ...formValue, noticeStatus: key });
  };

  const getCurrentFilterParams = async () => {
    const formValue = await getFormValue();
    const keyword = inputFilterRef.current?.input?.value || '';
    return {
      ...formValue,
      noticeStatus: tabStatus,
      keyword
    };
  };

  const getFormValue = async () => {
    const val = await searchCriteriaFromRef.current?.submitClick();

    const {
      provinceAndCity,
      publishTime,
      customerCompanyType,
      productLineKey,
      openTime,
      manufacturer,
      ...rest
    } = val;

    const { subjectMatterBrand } = dicList;

    const manufacturerItem = subjectMatterBrand.find(
      (item: any) => item.dictKey === manufacturer
    );

    const obj: NoticeListFilterInterface = {
      ...rest,
      customerCompanyType: customerCompanyType?.length
        ? customerCompanyType
        : null,
      productLineKey: productLineKey?.length ? productLineKey : null,
      manufacturer: manufacturerItem?.dictValue || ''
    };
    if (publishTime) {
      obj.publishTimeStart = dayjs(publishTime[0]).format(DEFAULT_DATE_FORMAT);
      obj.publishTimeEnd = dayjs(publishTime[1]).format(DEFAULT_DATE_FORMAT);
    }
    if (openTime) {
      obj.openTimeStart = dayjs(openTime[0]).format(DEFAULT_DATE_FORMAT);
      obj.openTimeEnd = dayjs(openTime[1]).format(DEFAULT_DATE_FORMAT);
    }
    if (provinceAndCity) {
      const provinceCodeList: any = [];
      provinceAndCity?.map((v: string[]) => {
        const provinceCode = getCityItem(v)?.code;
        provinceCodeList.push(provinceCode);
      });
      obj.provinceCodes = provinceCodeList;
    }
    return obj;
  };

  const handleInputSubmit = async () => {
    const val = inputFilterRef.current?.input?.value || '';
    const formValue = await getCurrentFilterParams();
    getList(pagination, {
      ...formValue,
      keyword: val
    });
  };

  //新建公告
  const handleCreateAnnouncement = () => {
    setOpen(true);
    subjectMatterForm.setFieldValue('subjectMatter', [
      initialSubjectMatterItemValues
    ]);
  };

  //新建公告
  const confirmAddNoticeCallback = async () => {
    const filterParams = await getCurrentFilterParams();
    getList(pagination, {
      ...filterParams
    });
  };

  return (
    <div className="project_wrap">
      <ZeissTabs
        defaultActiveKey={''}
        items={items}
        activeKey={tabStatus}
        onChange={onTabsChange}
        tabBarExtraContent={
          <div>
            <ZeissInput
              placeholder="信息标题/项目名称/客户单位/标的物/OPPID"
              allowClear
              style={{ width: 300 }}
              onPressEnter={handleInputSubmit}
              ref={inputFilterRef}
            />
            <ZeissButton
              type="primary"
              style={{ margin: '0 10px' }}
              icon={<SearchOutlined />}
              onClick={handleInputSubmit}
            />
            <ZeissButton
              type="primary"
              onClick={handleCreateAnnouncement}
              icon={<PlusOutlined />}
            >
              新建项目
            </ZeissButton>
          </div>
        }
      />
      <ProjectSearchForm
        ref={searchCriteriaFromRef}
        activeTab={tabStatus}
        dicList={dicList}
        systemCity={filterFormSystemCity}
        onFieldsChange={handleInputSubmit}
      />
      <ZeissTable {...tableProps} className="project_table_wrap" />

      <CreateProject
        mode={PROJECT_MODE.CREATE}
        formRef={form}
        noticeRecord={{}}
        record={{}}
        handleOk={handleProjectFormOk}
        open={open}
        setOpen={setOpen}
        dicList={dicList}
        systemCity={systemCity}
      />
      <RevertModal
        title="请确认是否撤回该项目?"
        open={revertModalShow}
        onCancel={() => setRevertModalShow(false)}
        onConfirm={onRevertConfirm}
      />
    </div>
  );
};
export default ProjectList;
